<template>
    <div class="mobile-navigation" :class="{ 'open': isMobileNavigationOpen }">
        <div v-if="isNavigationInitialized">

            <div class="mobile-nav-header d-flex justify-content-center">

                <div class="btn-close" @click="closeNavigation()"><i class="fa-light fa-xmark" aria-hidden="true"></i></div>

                <a class="hProfile" data-testing="login-select" v-if="!isLoggedIn" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                    <i class="fa-light fa-user-large hAccIcon" aria-hidden="true"></i>
                    <div class="hProfile">{{ $translate("Ceres::Template.login") }}</div>
                </a>

                <a href="#" class="dropdown-toggle nav-link" v-if="isLoggedIn">
                    <i class="fa-light fa-square-user hAccIcon" aria-hidden="true"></i>
                    <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
                </a>

            </div>

            <div class="mobile-nav-content">

                <div class="mobile-nav-group-title" v-if="!selectedCategory">
                    Alle Kategorien
                </div>

                <ul v-menu id="menu-1" class="mainmenu w-100 p-0 m-0 menu-active">
                    <li class="ddown mobile-nav-breadcrumb-container" v-if="dataContainer1.parent" @click="slideTo(dataContainer1.parent && dataContainer1.parent.parent || null, true)">
                        <span class="nav-direction btn-up">
                            <i class="fa-light fa-arrow-left" aria-hidden="true"></i>
                        </span>
                        <div v-if="parentCategory" class="mobile-nav-breadcrumb">{{ parentCategory.name }}</div>
                    </li>

                    <li class="ddown" v-for="category in dataContainer1.categories">
                        <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                        <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                            <i class="fa-light fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </li>
                    <template v-if="dataContainer1.categories[0]">
                        <li class="ddown" v-for="number in dataContainer1.categories[0].siblingCount - dataContainer1.categories.length">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                    <template v-else-if="dataContainer1.parent">
                        <li class="ddown" v-for="number in dataContainer1.parent.childCount">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                </ul>

                <ul v-menu id="menu-2" class="mainmenu w-100 p-0 m-0">
                    <li class="ddown mobile-nav-breadcrumb-container" v-if="dataContainer2.parent" @click="slideTo(dataContainer2.parent && dataContainer2.parent.parent || null, true)">
                        <span class="nav-direction btn-up">
                            <i class="fa-light fa-arrow-left" aria-hidden="true"></i>
                        </span>
                        <div v-if="parentCategory" class="mobile-nav-breadcrumb">{{ parentCategory.name }}</div>
                    </li>

                    <li  class="ddown" v-for="category in dataContainer2.categories">
                        <a :href="getCategoryUrl(category.url)">{{ category.details[0].name }}</a>
                        <span class="nav-direction" v-if="category.childCount" @click="slideTo(category)">
                            <i class="fa-light fa-angle-right" aria-hidden="true"></i>
                        </span>
                    </li>
                    <template v-if="dataContainer2.categories[0]">
                        <li class="ddown" v-for="number in dataContainer2.categories[0].siblingCount - dataContainer2.categories.length">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                    <template v-else-if="dataContainer2.parent">
                        <li class="ddown" v-for="number in dataContainer2.parent.childCount">
                            <span class="nav-placeholder m-3" :style="{width: (Math.random() * 20 + 60) + '%'}"></span>
                        </li>
                    </template>
                </ul>
            </div>
        </div>

        <template v-if="!isNavigationInitialized">

            <div class="mobile-nav-header d-flex justify-content-center">

                <div class="btn-close" @click="closeNavigation()"><i class="fa-light fa-xmark" aria-hidden="true"></i></div>

                <a class="hProfile" data-testing="login-select" v-if="!isLoggedIn" :href="isLogin ? 'javascript:void(0)' : '#login'" :data-toggle="isLogin ? false : 'modal'" @click="createLoginModal(); unmarkInputFields();" :aria-label="$translate('Ceres::Template.login')">
                    <i class="fa-light fa-user-large hAccIcon" aria-hidden="true"></i>
                    <div class="hProfile">{{ $translate("Ceres::Template.login") }}</div>
                </a>

                <a href="#" class="dropdown-toggle nav-link" v-if="isLoggedIn">
                    <i class="fa-light fa-square-user hAccIcon" aria-hidden="true"></i>
                    <span class="d-none d-sm-inline">{{ $translate("Ceres::Template.loginHello", {"username": username }) }}</span>
                </a>

            </div>

            <div class="mobile-nav-content">
                <loading-animation></loading-animation>
            </div>
        </template>

    </div>
</template>

<script>
// we replaced ./ with Ceres/components/itemList/  where Ceres is alias of  Ceres\resources\js\src\app
import mobileNavigation from "Ceres/components/pageDesign/MobileNavigation.vue";
import { mapGetters, mapActions } from "vuex";

export default {
    name: "mobile-navigation",
    extends: mobileNavigation,

    props: {
        breakpoints: {
            type: Array,
            default: () => ["xs", "sm", "md", "lg", "xl"]
        }
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },
    
    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ]),

        parentCategory() {

            return this.breadcrumbs.length > 0 ? this.breadcrumbs[this.breadcrumbs.length -1] : null;
        }

    },

    methods: {

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}


</script>
